export default {"src":"/_next/static/media/full-star.9055e288.svg","height":17,"width":17};